<template>
  <div class="card shadow-sm">
    <div class="card-header py-1 px-2">
      <fa-icon icon="heart-rate" /> vibration [g]
    </div>
    <div class="card-body">
      <div class="chart-placehoder" id="vib-chart-placeholder">
        <canvas id="vib-chart-area" width="250" height="100"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from '@/lib/chart.js'
import { mapGetters } from 'vuex'

export default {
  name: 'vibration',
  data () {
    return {
      chart: null,
      config: {
        type: 'line',
        data: {
          datasets: [
            {
              data: [1, 1, 1, 1],
              fill: false,
              lineTension: 0,
              borderColor: 'rgb(36, 64, 107)'
            }
          ],
          yHighlightRange: [
            {
              begin: 0,
              end: 1.2,
              backgroundColor: 'rgba(143, 251, 175, 0.1)'
            },
            {
              begin: 1.2,
              end: 1.5,
              backgroundColor: 'rgba(255, 255, 102, 0.1)'
            },
            {
              begin: 1.5,
              end: 2.0,
              backgroundColor: 'rgba(219, 54, 69, 0.1)'
            }
          ]
        },
        options: {
          responsive: true,
          events: [],
          animation: false,
          elements: {
            point: {
              backgroundColor: 'rgb(36, 64, 107)'
            }
          },
          title: {
            display: false
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  unit: 'second',
                  displayFormats: {
                    second: 'HH:mm:ss'
                  }
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stepSize: 0.5,
                  min: 0,
                  max: 2
                }
              }
            ]
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['colors', 'history', 'thresh']),
    vibData () {
      return this.history.vib
    }
  },
  watch: {
    vibData () {
      this.chart.data.datasets[0].data = this.vibData
      this.chart.update()
    }
  },
  methods: {
    createChart () {
      const ctx = document.getElementById('vib-chart-area').getContext('2d')
      this.chart = new Chart(ctx, this.config)
    }
  },
  mounted () {
    this.createChart()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Vibration.vue